import React from 'react'
import { useRegionBlogPosts } from '../../../RegionContent'
import styles from './styles.module.css'
import Text from '../../../Text'
import Img from '../../../Img'
import { formatDate } from '../../LegalDocumentPage'
import SmartLink from '../../../SmartLink'
import { $textSecondary } from '../../../../styles/colors/semantics'

function BlogPage({ title }) {
  const blogPosts = useRegionBlogPosts()

  return (
    <div className={styles.wrapper}>
      <div className={styles.titleWrapper}>
        <Text type="heading-1">{title}</Text>
      </div>
      <div className={styles.blogPostsWrapper}>
        <div className={styles.blogPostsList}>
          { [...blogPosts]
            .sort((a,b) => new Date(b.date) - new Date(a.date))
            .filter(p => p.visible && p.slug)
            .map(b => renderBlogPostThumbnail(b))
          }
        </div>
      </div>
    </div>
  )
}

export const renderBlogPostThumbnail = (blogPost) => {
  return (
    <SmartLink href={blogPost.slug} className={styles.blogPost}>
      <div className={styles.blogPostImage}>
        {/* task #67: render resolved thumbnail descriptor via <Img> (fills the aspect-ratio box) */}
        <Img image={blogPost.thumbnail} objectFit="cover" alt={blogPost.title} />
      </div>
      <div className={styles.textWrapper}>
        { blogPost.date &&
        <Text type="small" color={$textSecondary.light}>
          {formatDate(new Date(blogPost.date))}
        </Text>
        }
        <Text type="heading-6">{blogPost.title}</Text>
      </div>
    </SmartLink>
  )
}

export default BlogPage
